import React from 'react';
import './App.css';
import '@aws-amplify/ui-react/styles.css';
import './custom.css';
import { Segment, Grid } from 'semantic-ui-react';
import { Amplify } from 'aws-amplify';
import MenuBar from './MenuBar';
import { Authenticator, ThemeProvider } from "@aws-amplify/ui-react";
import awsconfig from './aws-exports';
import 'semantic-ui-css/semantic.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SymptomAssessment from './SymptomAssessments';
import SymptomAssessment_2 from './PSSAssessment';
import DataPrivacy from './DataPrivacy';
import PVT from './PVT';
import DailyNotes from './DailyNotes';
import Dash from './Dash';


Amplify.configure(awsconfig);
document.title = 'Client Portal - TREKMH';

// Custom Amplify Authenticator theme
const authTheme = {
  tokens: {
    colors: {
      background: { primary: '#f9f9f9' },
      font: { primary: '#333', secondary: '#555' },
      brand: { primary: '#302d4a', secondary: '#302d4a' },
    },
    components: {
      button: { primary: { backgroundColor: '#302d4a', color: '#fff', borderRadius: '6px' } },
      input: { backgroundColor: '#fff', borderColor: '#ccc', borderRadius: '6px' },
    }
  }
};

// Home component
function Home() {
  return (
    <Segment
      basic
      style={{
        marginTop: '15em',
        background: 'linear-gradient(135deg, #fefefe 0%, #f3f3f3 100%)',
        minHeight: '90vh',
        padding: 0,
      }}
    >
      <Grid centered verticalAlign="middle" style={{ minHeight: '90vh' }}>
        <Grid.Row>
          <div style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: '80px',
            textAlign: 'left',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            maxWidth: '1200px',
            width: '90%',
          }}>
            <h1 style={{ color: '#302d4a', fontSize: '36px', marginBottom: '1em' }}>
              Welcome to the TrekMH Measurement Based Care Platform
            </h1>
            <p style={{ fontSize: '30px', color: '#555' }}>
              A central digital hub for managing mental health and well-being. Here, you can complete validated assessments and track your clients symptoms over time.
            </p>
            <p style={{ fontSize: '30px', color: '#555' }}>
              To get started, use the menu above to navigate to the Sleep and Stress Assessment. 
            </p>
            <p style={{ fontSize: '30px', color: '#555' }}>
              Your privacy and data security are our top priorities. Please review our Data Privacy section to understand how we protect your clients information.
            </p>
          </div>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}

function AuthStateApp() {
  return (
    <ThemeProvider theme={authTheme}>
      <Authenticator hideSignUp={true}>
        {({ signOut, user }) => (
          <Router>
            <div className="App">
              <MenuBar signOut={signOut} username={user.username} />

              {/* Vertical margin wrapper */}
              <div style={{ marginTop: '5em', marginBottom: '5em' }}>
                <Routes>
                  {/* Home route */}
                  <Route path="/" element={<Home />} />

                  {/* PSQI Assessment Page */}
                  <Route path="/symptomassess" element={<SymptomAssessment />} />
                  {/* PTSS Assessment Page */}
                  <Route path="/symptomassess2" element={<SymptomAssessment_2 />} />
                  {/* PVT Page */}
                  <Route path="/pvt" element={<PVT />} />
                  {/* Data Privacy Page */}
                  <Route path="/dataprivacy" element={<DataPrivacy />} />
                  {/* Daily Notes Page */}
                  <Route path="/dailynotes" element={<DailyNotes />} />
                  {/* Dash Page */}
                  <Route path="/dashboard" element={<Dash />} />

                </Routes>
              </div>
            </div>
          </Router>
        )}
      </Authenticator>
    </ThemeProvider>
  );
}

const App = () => <AuthStateApp />;

export default App;
